/* eslint no-undef: 'off' */
import $ from 'jquery';


const apply_coupon = (coupon_code, datas = [], args = []) => {
    const ajax = themeObj.couponApply;
    return $.ajax({
        url: themeObj.ajaxUrl,
        method: 'POST',
        data: {
            action: ajax.action,
            nonce: ajax.nonce,
            coupon_code,
            ...datas,
        },
        ...args
    })
}

export default {
    apply_coupon,
}